import React from 'react'

import Box from 'components_new/atoms/Box'
import Divider from 'components_new/atoms/Divider'

export type TDataTooltipRow = {
  color?: string
  label: string
  unit?: string | null
  value: string
  valueColor?: string
}

interface DataTooltipContentProps {
  rows: TDataTooltipRow[]
  title: string

  /** Set apart below a divider, e.g. what the rows add up to. */
  total?: TDataTooltipRow
}

/** The chart tooltip's layout in React, for `<Tooltip variant="data">`. */
const DataTooltipContent = (props: DataTooltipContentProps) => {
  const { rows, title, total } = props

  const hasColors = rows.some((row) => row.color)

  const renderRow = (row: TDataTooltipRow) => (
    <Box component="tr" key={row.label}>
      {hasColors ? (
        <Box component="td" sx={{ px: '6px', py: '2px' }}>
          {row.color ? (
            <Box
              sx={{
                bgcolor: row.color,
                borderRadius: '4px',
                height: 8,
                width: 8
              }}
            />
          ) : null}
        </Box>
      ) : null}
      <Box
        component="td"
        sx={{
          color: 'text.secondary',
          pl: hasColors ? '6px' : 0,
          pr: '6px',
          py: '2px',
          whiteSpace: 'nowrap'
        }}
      >
        {row.label}
      </Box>
      <Box
        component="td"
        sx={{
          color: row.valueColor,
          fontVariantNumeric: 'tabular-nums',
          fontWeight: 'fontWeightBold',
          px: '6px',
          py: '2px',
          textAlign: 'right',
          whiteSpace: 'nowrap'
        }}
      >
        {row.value}
      </Box>
      <Box
        component="td"
        sx={{
          color: row.valueColor ?? 'text.secondary',
          p: '2px',
          whiteSpace: 'nowrap'
        }}
      >
        {row.unit}
      </Box>
    </Box>
  )

  return (
    <Box>
      <Box
        component="span"
        sx={{ fontWeight: 'fontWeightBold', whiteSpace: 'nowrap' }}
      >
        {title}
      </Box>
      <Box component="table" sx={{ borderCollapse: 'collapse', width: '100%' }}>
        <tbody>
          {rows.map(renderRow)}
          {total ? (
            <>
              <tr>
                <td colSpan={hasColors ? 4 : 3}>
                  <Divider sx={{ my: 0.5 }} />
                </td>
              </tr>
              {renderRow(total)}
            </>
          ) : null}
        </tbody>
      </Box>
    </Box>
  )
}

export default DataTooltipContent
